import React, { FunctionComponent } from 'react';
import { DynamicFieldProps } from '../DynamicField';
import { TypeConverterName, typeConverters } from '../typeConverters';
import { Answers, TextWithSuffixFieldSchema, TextWithSuffixField } from '../dynamicFormSchema';
import { InputWithSuffixSelect, InputWithSuffixValueSchema, InputWithSuffixValue } from '../../InputWithSuffixSelect';
import { DynamicFieldComponent } from './DynamicFieldComponentBase';

export const TextWithSuffixFieldComponent: FunctionComponent<DynamicFieldProps> = ({
  field,
  reactHookField,
  onChange
}) => {
  const ts = TextWithSuffixFieldSchema.parse(field);

  if (reactHookField.value) {
    // Make sure the value is in the correct format
    if (!InputWithSuffixValueSchema.safeParse(reactHookField.value).success) {
      throw new Error('Invalid value for TextWithSuffixField');
    }
  }

  return (
    <InputWithSuffixSelect
      {...ts}
      suffixValue={String(reactHookField.value.suffix)}
      inputValue={String(reactHookField.value.input)}
      onChange={onChange}
      disabled={reactHookField.disabled}
      inputType="text"
    />
  );
};

export class DynamicTextWithSuffixField extends DynamicFieldComponent<TextWithSuffixField, InputWithSuffixValue> {
  Component = TextWithSuffixFieldComponent;

  constructor(field: TextWithSuffixField) {
    super(field);
  }

  getAnswer(answers: Answers): InputWithSuffixValue {
    const answer = answers[this.field.name];
    if (answer === undefined) {
      return this.getDefaultValue();
    }

    if (InputWithSuffixValueSchema.safeParse(answer).success) {
      return answer as InputWithSuffixValue;
    }

    throw new Error(`Invalid answer for field ${this.field.name}`);
  }

  getDefaultValue(): InputWithSuffixValue {
    return {
      input: this.field.defaultValue || '',
      suffix: this.field.suffixDefaultValue || ''
    };
  }

  getValueToSubmit(value: InputWithSuffixValue): InputWithSuffixValue {
    if (!value) {
      return this.getDefaultValue();
    }

    const converter = typeConverters[this.field.fieldType as TypeConverterName];
    return {
      input: value?.input ? converter(value?.input) : '',
      suffix: value?.suffix || ''
    };
  }
}
